// extracted by mini-css-extract-plugin
module.exports = {"mainHeading":"Welcome_mainHeading__2FBZ7","content":"Welcome_content__1rFKr"};